/* eslint-disable no-empty */
import request from '@/api'
import ua from './platform'
import store from '@/store'

let appid = 'wx39fac88debc390da'
// 微信授权
export function wechatAuthCode() {
  if (!ua.isWeixin) {
    return
  }
  let params = window.location.href.split('?')
  let redirect_uri = encodeURIComponent(window.location.href)
  let response_type = 'code'
  let scope = 'snsapi_userinfo'
  let state = params.length > 1 ? encodeURIComponent(params[1]) : 'state'
  // const url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}&response_type=${response_type}&scope=${scope}&state=${state}&forcePopup=true&forceSnapShot=true#wechat_redirect`
  const url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}&response_type=${response_type}&scope=${scope}&state=${state}&forcePopup=true&forceSnapShot=${true}#wechat_redirect`
  window.location.href = url
}

//获取用户信息
export function getWxUserInfo(code) {
  return new Promise((resolve, reject) => {
    request
      .getUserInfo(code)
      .then((data) => {
        store.commit('setToken', data.member.token)
        resolve(data.member.token)
      })
      .catch(() => {
        // 重新刷新
        var url = delParam()
        window.location.replace(url)
        reject()
      })
  })
}

function delParam() {
  let code = 'code'
  let state = 'state'
  let url = window.location.href //页面url
  let urlParam = window.location.search.substr(1) //页面参数
  let beforeUrl = url.substr(0, url.indexOf('?')) //页面主地址（参数之前地址）
  let nextUrl = ''

  let arr = new Array()
  if (urlParam != '') {
    let urlParamArr = urlParam.split('&') //将参数按照&符分成数组
    for (let i = 0; i < urlParamArr.length; i++) {
      let paramArr = urlParamArr[i].split('=') //将参数键，值拆开
      //如果键与要删除的不一致，则加入到参数中
      if (paramArr[0] != state && paramArr[0] != code) {
        arr.push(urlParamArr[i])
      }
    }
  }
  if (arr.length > 0) {
    nextUrl = '?' + arr.join('&')
  }
  url = beforeUrl + nextUrl
  return url
}

// 微信sdk初始化
export function initSign(data, title, desc, imgUrl = 'https://content.foshanplus.com/foshanlogo.png') {
  import('weixin-js-sdk')
    .then((wx) => {
      let { appid, timestamp, nonceStr, signature, link } = data
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: appid, // 必填，公众号的唯一标识
        timestamp: timestamp, // 必填，生成签名的时间戳
        nonceStr, // 必填，生成签名的随机串
        signature: signature, // 必填，签名，见附录1
        // jsApiList: ['updateTimelineShareData', 'updateAppMessageShareData', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone'],
        jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone'],
        openTagList: ['wx-open-launch-weapp', 'wx-open-launch-app']
      })

      // config信息验证后会执行ready方法，
      // 所有接口调用都必须在config接口获得结果之后，
      // config是一个客户端的异步操作，
      // 所以如果需要在页面加载时就调用相关接口，
      // 则须把相关接口放在ready函数中调用来确保正确执行。
      // 对于用户触发时才调用的接口，则可以直接调用，
      // 不需要放在ready函数中。

      try {
        if (link && link != null) {
          link = link + "&time=" + new Date().getTime();
        } else {
          link = delParam(link, "code", "state");
          link = link + "&time=" + new Date().getTime();
        }
      } catch (error) {}
      
      wx.ready(function () {
        let shareMsg = {
          title: title, // 分享标题
          desc: desc, // 分享描述
          link: link, // 分享链接
          imgUrl, // 分享图标
          success: function () {
            // 用户确认分享后执行的回调函数
          },
          cancel: function () {
            // 用户取消分享后执行的回调函数
          }
        }
        //分享到朋友圈
        wx.onMenuShareTimeline({
          ...shareMsg,
          success: function () {
            // 用户确认分享后执行的回调函数
            console.log('onMenuShareTimeline')
            pocPostShare()
          }
        })
        //分享给朋友
        wx.onMenuShareAppMessage({
          ...shareMsg,
          type: 'link', // 分享类型,music、video或link，不填默认为link
          dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
          success: function () {
            // 用户确认分享后执行的回调函数
            console.log('onMenuShareAppMessage')
            pocPostShare()
          }
        })
        // //分享到朋友圈
        // wx.updateTimelineShareData(shareMsg)
        // //分享给朋友
        // wx.updateAppMessageShareData({
        //   ...shareMsg,
        //   type: 'link', // 分享类型,music、video或link，不填默认为link
        //   dataUrl: '' // 如果type是music或video，则要提供数据链接，默认为空
        // })
        //分享到QQ
        wx.onMenuShareQQ(shareMsg)
        //分享到腾讯微博
        wx.onMenuShareWeibo(shareMsg)
        //分享到QQ空间
        wx.onMenuShareQZone(shareMsg)

        wx.error(function (e) {
          console.log('wx.error', e)
          // config信息验证失败会执行error函数，
          // 如签名过期导致验证失败，
          // 具体错误信息可以打开config的debug模式查看，
          // 也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
        })
      })
    })
    .catch((error) => {
      console.log('加载weixin-js-sdk失败', error)
    })
}

// 分享
export function wxShare(title, desc, img) {
  request.getSign(appid).then((res) => {
    res.link = window.location.href //页面url
    initSign(res, title, desc, img)
  })
}

// [埋点] 点击转发按钮-仅帖子上报
function pocPostShare() {
  const url = window.location.href
  // 帖子才上报
  if (!url.includes('moment.html')) return

  const urlQs = parseQuerySearch(url)
  if (!urlQs.id) return
  // 帖子分享埋点
  request.getPostDetail(urlQs.id).then((res) => {
    const item = res.post
    let _poc_event_params = {
      content_id: item.id,
      user_code: item.memberId,
      author_name: item.memberNickname
    }
    // eslint-disable-next-line no-undef
    qaplus.event.record('fsplush5_share_click', 2101, _poc_event_params)
    // eslint-disable-next-line no-undef
    pocplus.event.record('fsplush5_share_click', _poc_event_params)
  })
}

// search字符串转对象
function parseQuerySearch(url) {
  const obj = {}
  const search = url.split('?')[1]
  if (search) {
    const arr = search.split('&')
    arr.forEach((i) => {
      const [key, value] = i.split('=')
      obj[key] = value
    })
  }
  return obj
}
